/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import login_logo from "../../../images/loginlogo.png";
import { Button } from "@mui/material";
import "./EmailVerify.css";
import HorizontalLinearStepper from "../../Stepper/Stepper";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  userOtpVerificationApi,
  userResendOtpApi,
} from "../../../Services/Login/LoginApi/loginApi";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function EmailVerificationComp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const [email, setEmail] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true); // Controls button state
  const [timer, setTimer] = useState(30); // Timer starts at 30 seconds
  const id = localStorage.getItem("su_id");

  // Timer to show the button after 30 seconds
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000); // Decrease timer every second
    } else {
      setIsButtonDisabled(false); // Enable button when timer reaches 0
      clearInterval(interval);
    }

    return () => clearInterval(interval); // Cleanup on unmount
  }, [timer]);

  useEffect(() => {
    // Check localStorage
    const stepTwoComplete = localStorage.getItem("signupStepTwoComplete");

    if (!stepTwoComplete || !id) {
      navigate("/signupone"); // Redirect to first step
      localStorage.removeItem("signupFormData");
    }
  }, [id, navigate]);

  useEffect(() => {
    const savedEmail = localStorage.getItem("signUpEmail");
    setEmail(savedEmail); // Update the email state

    const stepTwoComplete = localStorage.getItem("signupStepTwoComplete");

    if (!stepTwoComplete || !savedEmail) {
      navigate("/signupone");
      localStorage.removeItem("signupFormData");
    }
  }, [navigate]);

  const handleChange = (index, value) => {
    if (/^\d*$/.test(value) && value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to the next input
      if (value && index < 3) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const combinedOtp = otp.join(""); // Combine OTP digits

    try {
      dispatch(
        userOtpVerificationApi({
          otp: combinedOtp,
          otp_type: "email_verification",
          user_id: id,
        })
      ).then((res) => {
        if (res?.payload?.status === 200) navigate("/email-verified");
        else toast.error(res?.payload?.message);
      });
    } catch (error) {
      console.error("Error during OTP verification", error);
    }
  };

  const handleResendOtp = async () => {
    setIsButtonDisabled(true); // Disable button again after click
    setTimer(30); // Reset timer
    dispatch(
      userResendOtpApi({
        user_id: id,
        otp_type: "email_verification",
      })
    );
  };

  return (
    <section className="login-page-one confirm-acc-section">
      <div className="container-fluid p-0">
        <div className="row m-0 confirm-blk-singupflow">
          <div className="col-md-6">
            <div className="login-right-block logo-left-block mb-0">
              <div className="login-logoimg text-center forgotpw-block">
                <Link to="/">
                  <img src={login_logo} alt="login-logo" />
                </Link>
              </div>
              <div className="back-btn">
                <button
                  onClick={() => navigate(-1)}
                  className="back-btn-button"
                >
                  <ArrowBackIcon className="left-icon" />
                  Back
                </button>
              </div>
            </div>
            <div className="banner-contents">
              <div className="banner-image">
                {/* <img src={banner_img} alt="banner-image"></img> */}
                <div className="text-overlay">
                  <h5>Let's Setup Your Operating Agreement</h5>
                  <p>
                    Elevate your business insights with precision. Log in to
                    discover and refine your Ideal Customer Profiles
                    effortlessly.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 email-verify-col">
            <div className="login-right-block desktop-view">
              <div className="login-logoimg text-center forgotpw-block">
                <img
                  src={login_logo}
                  alt="login-logo"
                  className="login_logo_img"
                ></img>
              </div>
              <div className="stepper d-flex justify-content-between align-items-center">
                {/* <div className="stepper-innner">
                                                  <a className=" d-flex flex-column align-items-center gap-1">
                                                    <div className="stepper-dot-fade active"></div>
                                                    <div className="step-no-fade active">Step 1</div>
                                                  </a>
                                                </div>
                                                <div className="stepper-line "></div>
                                                <div className="stepper-innner">
                                                  <Link
                                                    onClick={handleSubmit}
                                                    className=" d-flex flex-column align-items-center gap-1"
                                                  >
                                                    <div className="stepper-dot-fade"></div>
                                                    <div className="step-no-fade">Step 2</div>
                                                  </Link>
                                                </div> */}
                <HorizontalLinearStepper activeStepProp={2} />
              </div>
              {/* <div className='back-btn'>
                                    <a href="javascript:void(0)"><img src={chevronleft} alt='chevron-left' className='left-icon'></img>Back
                                    </a>
                                </div> */}
            </div>
            <div className="stepper stepper-responsive mb-4 d-flex justify-content-between align-items-center">
              {/* <div className="stepper-innner">
                                                              <Link
                                                                to="/signupone"
                                                                className=" d-flex flex-column align-items-center gap-1"
                                                              >
                                                                <div className="stepper-dot-fade active"></div>
                                                                <div className="step-no-fade active">Step 1</div>
                                                              </Link>
                                                            </div>
                                                            <div className="stepper-line active"></div>
                                                            <div className="stepper-innner">
                                                              <a className=" d-flex flex-column align-items-center gap-1">
                                                                <div className="stepper-dot-fade active"></div>
                                                                <div className="step-no-fade active">Step 2</div>
                                                              </a>
                                                            </div> */}
              <HorizontalLinearStepper activeStepProp={2} />
            </div>
            <div className="confirm-page">
              <div className="login-information">
                <h1 className="text-center m-0">
                  Enter Email Verification Code
                </h1>
                <p className="pw-texts text-center mt-1">
                  We've sent a code to {email}
                </p>
                <div className="form-login text-left">
                  <div className="mb-4">
                    <div className="otp-input-container">
                      {/* <input
                                            type="number"
                                            maxLength="1"
                                            className="otp-input"
                                            value={digit1}
                                            onChange={(event) => setDigit1(event.target.value)}
                                            />
                                            <input
                                            type="number"
                                            maxLength="1"
                                            className="otp-input"
                                            value={digit2}
                                            onChange={(event) => setDigit2(event.target.value)}
                                            />
                                            <input
                                            type="number"
                                            maxLength="1"
                                            className="otp-input"
                                            value={digit3}
                                            onChange={(event) => setDigit3(event.target.value)}
                                            />
                                            <input
                                            type="number"
                                            maxLength="1"
                                            className="otp-input"
                                            value={digit4}
                                            onChange={(event) => setDigit4(event.target.value)}
                                            /> */}
                      {otp.map((digit, index) => (
                        <input
                          key={digit + index}
                          type="text"
                          maxLength="1"
                          className="otp-input"
                          value={digit}
                          onChange={(e) => handleChange(index, e.target.value)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          ref={(el) => (inputRefs.current[index] = el)}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="btn-orange">
                    <Button onClick={handleSubmit}>Verify</Button>
                  </div>
                  <div className="lower-signup-text text-center">
                    {/* <p>Didn’t recieved the verification OTP? <a href="#" onClick={() => handleResendOtp()} className="text-orange">Resend OTP</a></p> */}
                    <p>
                      Didn’t receive the verification OTP?{" "}
                      {isButtonDisabled ? (
                        <span>Resend OTP in {timer}s</span>
                      ) : (
                        <a
                          href="#"
                          onClick={() => handleResendOtp()}
                          className={`text-orange ${
                            isButtonDisabled
                              ? "opacity-50 cursor-not-allowed pointer-events-none"
                              : ""
                          }`}
                        >
                          Resend OTP
                        </a>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EmailVerificationComp;
